export default __webpack_public_path__ + "static/media/announcement.1f4c703b.svg";